import logger from 'OK/logger';

var visibilityHidden = null;
var visibilityChange = null;

var currentState = "nogwt";
var isAnyLayerOpen = false;
var MAX_FPS = 60;

var testTime = 5000;
var fpsStatLimit = 30;
var threshold = 100;
var lagCountLimit = 5;
var percentilesParam = [50];
var framePeriod = 1000;

var startTimestamp = 0;
var lastTimestamp = 0;
var frameTimestamp = 0;
var lagCount = 0;
var frameCount = 0;
var requestFrameId = null;
var frameStack = [];

var measureWasStarted = false;
var performanceObserver;
var longTaskLagCount = 0;

function dispatchPerformanceLogEvent(type, value) {
    document.body.dispatchEvent(new CustomEvent('performance-event', {
        detail: {
            type: type,
            value: value
        },
        bubbles: true
    }));
}

function checkModal() {
    return OK && OK.Layers && OK.Layers.isAnyLayerOpened();
}

(function setVisibilityConstants() {
    if (document.hidden !== undefined) {
        visibilityHidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (document.mozHidden !== undefined) {
        visibilityHidden = "mozHidden";
        visibilityChange = "mozvisibilitychange";
    } else if (document.msHidden !== undefined) {
        visibilityHidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (document.webkitHidden !== undefined) {
        visibilityHidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }
}());

function check(now) {
    if (now - lastTimestamp > threshold) {
        lagCount += 1;
    }
    lastTimestamp = now;

    // Сохраняем количество отрисовок за заданный период времени
    if (now - frameTimestamp >= framePeriod) {
        frameStack.push(frameCount);
        frameCount = 0;
        frameTimestamp = now;
    } else {
        frameCount += 1;
    }

    if (now - startTimestamp > testTime) {
        stop(true);
    } else {
        requestFrameId = window.requestAnimationFrame(check);
    }
}

function start() {
    lagCount = 0;
    longTaskLagCount = 0;
    frameCount = 0;
    lastTimestamp = window.performance.now();
    startTimestamp = lastTimestamp;
    frameTimestamp = lastTimestamp;
    isAnyLayerOpen = checkModal();
    measureWasStarted = true;
    requestFrameId = window.requestAnimationFrame(check);
}

/**
 * Вернет мап перцентиль из заданного списка на значение из собранных данных
 * @param {Array.<number>} data массив, в котором каждая цифра — это количество отрисовок за околосекунду
 * @param {Array.<number>} params список желаемых персентилей, например [25,50,75]
 * @returns {{}}
 */
function buildPercentilesMap(data, params) {
    var result = {};

    // Перцентиль в дискретном ряду — это просто позиция элемента в сортированном массиве
    // https://en.wikipedia.org/wiki/Quantile
    data.sort(function (a, b) {
        return a - b;
    });

    params.forEach(function (param) {
        if (param) {
            // Лучше округлять вниз. Значение N-тиля должно гарантировать,
            // что как минимум N процентов выборки меньше либо равны этому значению.
            // Для рядов с чётной длиной будем брать нижнюю границу, не усложняя
            var position = Math.floor((data.length - 1) * (param / 100));
            result['p' + param] = data[position];
        }
    });
    return result;
}

/**
 * Реализует расчет списка кадров за последнюю секунду для каждого момента времени из списка
 * Требуется для увеличения статистической выборки
 * Пример: снимаем замеры в течение 2х секунд с интервалом в 100мс, имеем список из 20 значений
 * Результатом будет 11 значений, каждое из которых будет содержать сумму, собранную за секунду времени
 * @param {Array.<number>} quantum
 * @returns {Array.<number>}
 */
function regularFrameFromQuantum(quantum) {
    var result = [];
    // сколько моментов было в секунде
    var quantumCount = 1000 / framePeriod;
    var sum, i, j;
    // скользим по исходному списку значений
    for (i = quantumCount - 1; i < quantum.length; i++) {
        // Для i-ой позиции считаем сумму значений за предшествующую секунду
        sum = 0;
        for (j = 0; j < quantumCount; j++) {
            sum += quantum[i - j];
        }
        result.push(sum);
    }
    return result;
}

/**
 *
 * @param {boolean} success Сбор данных завершен штатно, можно логировать
 */
function stop(success) {
    window.cancelAnimationFrame(requestFrameId);
    requestFrameId = null;
    measureWasStarted = false;

    var state = currentState;
    // Модалкам веры нет
    if (isAnyLayerOpen || checkModal()) {
        state = 'layer';
    }

    if (success) {
        // Не должны логироваться заграничные значения
        if (logger.duration) {
            if ((lagCount > lagCountLimit) && (lagCount < (testTime / threshold))) {
                logger.duration('framerate', lagCount, state);
                dispatchPerformanceLogEvent('framerate', {
                    lagCount: lagCount,
                    state: state
                });
            }
            if (longTaskLagCount > lagCountLimit) {
                logger.duration('longtask.duration', longTaskLagCount, state);
                dispatchPerformanceLogEvent('longtask', {
                    lagCount: longTaskLagCount,
                    state: state
                });
            }
        }
        start();
    } else {
        // В этой ветке обрабатываем накопленные значения fps
        // Нам необходим увеличенный набор данных для получения персентилей,
        // 5секундного интервала для построения такого набора мало.
        // Поэтому накапливаем все значения, пока не случился навигационный переход, переключение вкладки в фон, ...
        // Накопленные значения затем нарезаем на равные по размеру вектора
        var stack = regularFrameFromQuantum(frameStack);
        var tmpArr, dataMap;
        var j, val, mean;
        while(stack.length >= fpsStatLimit) {
            // splice будет мутировать исходный массив, поэтому у цикла такое условие
            tmpArr = stack.splice(0, fpsStatLimit);

            mean = 0;
            for (j = 0; j < fpsStatLimit; j++) {
                val = tmpArr[j];
                // Будем считать, что больше 60 fps не бывает, срежем выбросы
                if (val > MAX_FPS) {
                    logger.duration('overFpsLimit', val);
                    val = MAX_FPS;
                    tmpArr[j] = val;
                }
                mean += val;
            }

            dataMap = buildPercentilesMap(tmpArr, percentilesParam);

            dataMap.mean = Math.floor(mean / fpsStatLimit);
            dataMap.min = Math.min.apply(null, tmpArr);
            dataMap.max = Math.max.apply(null, tmpArr);
            dataMap.state = state;

            // Залогируем медиану и стейт в чартс
            logger.duration('altFramerate', dataMap.p50 || 0, state, JSON.stringify(dataMap));

            dispatchPerformanceLogEvent('altFramerate', dataMap);
        }
        frameStack = [];
    }
}

function navigationHandler() {
    stop(false);
    currentState = OK.getCurrentDesktopModelId();
    start();
}

function visibilityChangeListener() {
    if (document[visibilityHidden]) {
        stop(false);
    } else {
        start();
    }
}

function activate(element) {
    testTime = Number(element.getAttribute("data-test-time")) || testTime;
    threshold = Number(element.getAttribute("data-threshold")) || threshold;
    lagCountLimit = element.hasAttribute("data-limit") ? Number(element.getAttribute("data-limit")) : lagCountLimit;
    fpsStatLimit = element.hasAttribute("data-stat-limit") ? Number(element.getAttribute("data-stat-limit")) : fpsStatLimit;
    framePeriod = element.hasAttribute("data-frame-period") ? Number(element.getAttribute("data-frame-period")) : framePeriod;
    percentilesParam = element.hasAttribute("data-percentiles")
        ? element.getAttribute("data-percentiles").split(',').map(function (value) {
            return Number(value);
        })
        : percentilesParam;
    currentState = (OK.getCurrentDesktopModelId && OK.getCurrentDesktopModelId()) || currentState;

    if ("PerformanceObserver" in window) {
        try {
            performanceObserver = new PerformanceObserver(function(entryList) {
                var entries = entryList.getEntries();
                for (var i = 0; measureWasStarted && (i < entries.length); i++) {
                    longTaskLagCount += 1;
                }
            }).observe({
                entryTypes: ["longtask"]
            });
        } catch (e) {
            logger.success('longtask.error', 'unsupported');
        }
    }

    if (visibilityChange) {
        window.addEventListener("navigationStateChanged", navigationHandler);
        document.addEventListener(visibilityChange, visibilityChangeListener, false);
    }
    start();
}

function deactivate() {
    stop(false);

    if (performanceObserver) {
        performanceObserver.disconnect();
    }

    if (visibilityChange) {
        window.addEventListener("navigationStateChanged", navigationHandler);
        document.removeEventListener(visibilityChange, visibilityChangeListener);
    }
}

export default { activate, deactivate };

export { activate, deactivate };
